import moment from "moment";
import steem from "steem";
import store from "@/store";
import { ITransaction } from "@/interfaces";
import { BigNumber } from "@/utils";
import numeral from "numeral";
const locale = store.getters["ui/locale"];

export default {
  methods: {
    readableReputation(account: any) {
      return steem.formatter.reputation(account.reputation);
    },

    readableUpvoteValue(account: any, weight: number, precision: number) {
      const properties = store.state["network"].properties;
      if (properties && properties.reward_fund) {
        const total_vests =
          Number(account.vesting_shares.split(" ")[0]) +
          Number(account.received_vesting_shares.split(" ")[0]) -
          Number(account.delegated_vesting_shares.split(" ")[0]);
        const final_vest = total_vests * 1e6;
        let power = (account.voting_power * weight / 10000) / 50;
        const rshares = power * final_vest / 10000;
        let estimate =
          rshares / properties.reward_fund.recent_claims *
          properties.reward_fund.reward_balance *
          properties.median_history.price;
        console.log(estimate, store.state["currency"].sbdrate, store.state["currency"].steemrate)

        // estimate = (estimate/2*store.state["currency"].sbdrate) + (estimate/2* store.state["currency"].steemrate);
        return Number(parseFloat(estimate.toString()).toFixed(precision));
      } else return 0;
    },

    readableVotingPower(account: any, precision: number) {
      const totalShares =
        parseFloat(account.vesting_shares) +
        parseFloat(account.received_vesting_shares) -
        parseFloat(account.delegated_vesting_shares) -
        parseFloat(account.vesting_withdraw_rate);
      const elapsed = Math.floor(Date.now() / 1000) - account.voting_manabar.last_update_time;
      const maxMana = totalShares * 1000000;
      let currentMana = parseFloat(account.voting_manabar.current_mana) + (elapsed * maxMana) / 432000;
      if (currentMana > maxMana) {
        currentMana = maxMana;
      }
      const currentManaPerc = (currentMana * 100) / maxMana;
      return parseFloat(currentManaPerc.toString()).toFixed(precision);
    },

    readableSteemPower(account: any, precision: number) {
      if (account && (account.vesting_shares || account.delegated || account.received_vesting_shares)) {
        let SP = 0;
        SP = SP + Number(this.vestToSteemPower(account.vesting_shares.split(" ")[0]));
        SP = SP - Number(this.vestToSteemPower(account.delegated_vesting_shares.split(" ")[0]));
        SP = SP + Number(this.vestToSteemPower(account.received_vesting_shares.split(" ")[0]));
        return parseFloat(SP.toString()).toFixed(precision);
      }
    },

    vestToSteemPower(vest: number) {
      if (
        store.state["network"] &&
        store.state["network"].properties &&
        store.state["network"].properties.total_vesting_fund_steem &&
        vest
      ) {
        const globals = store.state["network"].properties;
        const totalSteem = parseFloat(globals.total_vesting_fund_steem.split(" ")[0]);
        const totalVests = parseFloat(globals.total_vesting_shares.split(" ")[0]);
        const SP = totalSteem * (vest / totalVests);
        return Number(parseFloat(SP.toString()).toFixed(3));
      }
    },
    estimateAccountValue(account: any) {
      const balanceSteem = parseFloat(account.balance.split(" ")[0]);
      const balanceSbd = parseFloat(account.sbd_balance.split(" ")[0]);
      let balanceUsd = 0;
      balanceUsd += store.state["currency"].rate * Number(this.vestToSteemPower(account.vesting_shares.split(" ")[0]));
      balanceUsd += store.state["currency"].rate * balanceSteem;
      balanceUsd += store.state["currency"].sbdrate * balanceSbd;
      return balanceUsd;
    },

    estimateAccountValueShort(account: any) {
      const balanceSteem = parseFloat(account.balance.split(" ")[0]);
      const balanceSbd = parseFloat(account.sbd_balance.split(" ")[0]);
      let balanceUsd = 0;
      balanceUsd += store.state["currency"].rate * Number(this.vestToSteemPower(account.vesting_shares.split(" ")[0]));
      balanceUsd += store.state["currency"].rate * balanceSteem;
      balanceUsd += store.state["currency"].sbdrate * balanceSbd;
      return Number(parseFloat(balanceUsd.toString()).toFixed(2));
    },

    readableTimestamp(value: number): string {
      return moment(value)
        .utc()
        .format("L LTS");
    },

    readableTimestampAgo(time: number, compareTime: number | undefined): string {
      const momentTime = moment.utc(time);
      return typeof compareTime !== "undefined" ? momentTime.from(moment(compareTime).utc()) : momentTime.fromNow();
    },
    readableTimestampAgoBlock(block: number): string {
      const sec = (this.$store.state.network.height - block) * 3 * 1000;
      const utc = new Date(this.$store.state.network.blocktime).getTime() - sec;
      const momentTime = moment.utc(utc);
      return momentTime.from(moment(this.$store.state.network.blocktime).utc());
    },

    readableNumber(value: number, digits = 0, omitSeparator = false): string {
      if (!isNaN(value))
        return Number(value).toLocaleString(locale);
      else return "0";
    },
    shortNumber(value: number): string {
      if (!isNaN(value))
        return numeral(value).format('0.0a');
      else return "0";
    },
  },
};
